import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { EventEmitter, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Media, MediaSource } from './templates/template-constants';
import { BehaviorSubject, Observable } from 'rxjs';
import { Blog, BlogFilterRequest, Blog_Cachekeys } from './admin-blogs/blog';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Injectable({
  providedIn: 'root',
})
export class TemplateMasterService {
  private accessKey: string = 'r0op0wwV9BVOxHnc-USH9vLMQhFAOVbEyIfPPVNu6hE';
  private apiUrl = 'https://api.unsplash.com';
    secondaryEditor = new EventEmitter<any>();
  goBack = new EventEmitter<any>();
  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    private snackbar: MatSnackBar,
    private readonly bottomSheet: MatBottomSheet,
  ) {}

  private _$dataChangedInText: BehaviorSubject<void> =
    new BehaviorSubject<void>(undefined);
  private editComponent: { style: any; content: any; action: any } = {
    style: null,
    content: null,
    action: null,
  };

  get dataChangedText() {
    return this._$dataChangedInText.asObservable();
  }
  setDataChangedText() {
    this._$dataChangedInText.next();
  }

  debounce(fn, duration: number = 500) {
    let timeout: ReturnType<typeof setTimeout> | null = null;

    return function () {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => fn(), duration);
    };
  }

  openSnackbar(message: string) {
    this.snackbar.open(message, 'Ok', {
      duration: 1500,
    });
  }

  openSnack(message: any, action: any) {
    this.snackbar.open(message, action, { duration: 5000 });
  }
  openDialogWithData(
    componentName: any,
    height: any,
    width: any,
    dataModel: any,
  ) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
      maxWidth: '100vw',
      maxHeight: '100vh',
    });
  }

  openDialog(componentName: any, height: any, width: any, dataModel: any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
      maxWidth: '100vw',
    });
  }

  openServiceDialog(
    componentName: any,
    height: any,
    width: any,
    maxWidth: any,
    dataModel: any,
    position: any = { right: '0px', top: '0px' },
  ) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      maxWidth: maxWidth,
      data: dataModel,
      disableClose: true,
      position: position,
    });
  }

  openDeleteDialog(
    componentName: any,
    height: any,
    width: any,
    dataModel: any,
    maxwidth: any,
  ) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
      maxWidth: maxwidth,
      // position: { right: '0' },
    });
  }

  // for listing in template category
  getCategoryList(size: number, page: number) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/template/category?size=${size}&page=${page}`,
    );
  }

  // for search category in template
  getSerarchCategory(page: number, size: number, searchText: any) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/template/category?size=${size}&page=${page}&text=${searchText}`,
    );
  }

  // for add category in template
  addCategory(data: any) {
    return this.http.post(
      environment.baseUrl + `admin/master/template/category`,
      data,
    );
  }

  // for Edit/Update category in template
  updateCategory(data: any) {
    return this.http.put(
      environment.baseUrl + `admin/master/template/category`,
      data,
    );
  }

  deleteCategory(id: any) {
    return this.http.delete(
      environment.baseUrl + `admin/master/template/category/${id}`,
    );
  }

  // for listing in template content
  getContentList(size: number, page: number) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/template/content?size=${size}&page=${page}`,
    );
  }

  getContentListV2(
    subIndustryId: string,
    categoryId: string,
    pageNo: number,
    size: number,
  ) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/template/v2/component?categoryId=${categoryId}&subIndustryId=${subIndustryId}&size=${size}&page=${pageNo}`,
    );
  }

  getContentList3(subIndustryId: string, categoryId: string) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/template/v2/content/component?categoryId=${categoryId}&subIndustryId=${subIndustryId}`,
    );
  }

  // for search content in template
  getSearchContent(page: number, size: number, searchText: any) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/template/content?size=${size}&page=${page}&text=${searchText}`,
    );
  }
  //  for add content in template
  addContent(data: any) {
    return this.http.post(
      environment.baseUrl + `admin/master/template/content`,
      data,
    );
  }

  // for listing in template component
  getComponentList(size: number, page: number) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/template/component?size=${size}&page=${page}`,
    );
  }

  // for search component in template
  getSearchComponent(searchText: any) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/template/v2/component/master?text=${searchText}`,
    );
  }

  // for add component in template
  addTemplateComponent(data: any) {
    return this.http.post(
      environment.baseUrl + `admin/master/template/v2/component/master`,
      data,
    );
  }

  // get all components by category
  getAllComponentsByCategory() {
    return this.http.get(
      environment.baseUrl + `admin/master/template/v2/component/master`,
    );
  }

  getAllComponentsByCategoryId(categoryId: any) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/template/v2/component/master?categoryId=${categoryId}`,
    );
  }

  getComponentsById(id: any) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/template/v2/get/master/component?id=${id}`,
    );
  }

  getSingleComponentById(id: any) {
    return this.http.get(environment.serverIp + `v3/component/${id}`);
  }
  getComponentPromptById(id: any) {
    return this.http.get(
      environment.baseUrl + `admin/master/template/component/prompt?id=${id}`,
    );
  }
  updateComponentPromptData(data: any) {
    return this.http.put(
      environment.baseUrl + `admin/master/template/component/prompt`,
      data,
    );
  }

  getSinglePage(id: any) {
    return this.http.get(environment.baseUrl + `admin/v3/page?id=${id}`);
  }

  getComponentsByCategoryId(categoryId: any) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/template/v2/component/master/${categoryId}`,
    );
  }

  getComponentsCount(status?: string) {
    if (status) {
      return this.http.get(
        environment.baseUrl +
          `admin/master/template/v2/get/master/component/count?status=${status}`,
      );
    } else {
      return this.http.get(
        environment.baseUrl +
          `admin/master/template/v2/get/master/component/count`,
      );
    }
  }

  getComponentsByCategoryIdAndStatus(categoryId: any, status: string) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/template/v2/component/master/${categoryId}?status=${status}`,
    );
  }
  //delete comopnent
  deleteComponent(componentId: any) {
    return this.http.delete(
      environment.baseUrl +
        `admin/master/template/v2/component/master?id=${componentId}`,
    );
  }

  getSubIndustryByIndustry(industryId: any) {
    return this.http.get(
      environment.baseUrl + `admin/master/business/industry/sub/${industryId}`,
    );
  }
  getComponentDetails(componentId: any) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/template/v2/component/master?id=${componentId}`,
    );
  }

  mergedIndustrySubIndustry() {
    return this.http.get(
      environment.baseUrl +
        `admin/master/business/industry/sub?size=1000&page=0`,
    );
  }

  createPage(data) {
    return this.http.post(
      environment.baseUrl + `admin/master/template/v2/page`,
      data,
    );
  }

  getAllLocalElements() {
    return this.http.get(
      environment.baseUrl + `admin/master/template/v2/component/images`,
    );
  }

  createComponentForPage(data, componentId, index) {
    return this.http.post(
      environment.baseUrl +
        `admin/master/template/v2/page/component?componentId=${componentId}&index=${index}`,
      data,
    );
  }

  createComponentForTemplate(pageId, componentId, index, templateId) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/template/v2/${templateId}/component/add?componentId=${componentId}&index=${index}&pageId=${pageId}`,
    );
  }

  savePageDataWithComponents(data) {
    return this.http.put(
      environment.baseUrl + `admin/master/template/v2/page`,
      data,
    );
  }

  getListOfAllPages() {
    return this.http.get(environment.baseUrl + `admin/master/template/v2/page`);
  }

  getListAllPagesWithSubIndustry(subIndustryId) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/template/v2/page?subIndustryId=${subIndustryId}`,
    );
  }

  // pageNameCategories() {
  getListAllPagesWithSubIndustrySearchText(subIndustryId: any, text: any) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/template/v2/page?subIndustryId=${subIndustryId}&text=${text}`,
    );
  }

  pageNameCategories() {
    return this.http.get(
      environment.baseUrl + `admin/master/template/v2/page/category`,
    );
  }

  duplicatePage(payload) {
    return this.http.post(
      environment.baseUrl + `admin/v3/duplicate/page`,
      payload,
    );
  }

  deletePage(pageId) {
    return this.http.delete(
      environment.baseUrl + `admin/v3/page?pageId=${pageId}`,
    );
  }

  searchPages(searchWord) {
    return this.http.get(
      environment.baseUrl + `admin/master/template/v2/page?text=${searchWord}`,
    );
  }

  //templates
  createTemplate(data) {
    return this.http.post(
      environment.baseUrl + `admin/master/template/v2/`,
      data,
    );
  }
  getListOfTemplates() {
    return this.http.get(environment.baseUrl + `admin/master/template/v2/`);
  }
  getSingleTemplateDetails(id) {
    return this.http.get(
      environment.baseUrl + `admin/master/template/v2/${id}`,
    );
  }

  v3GetSingleTemplateDetails(id) {
    return this.http.get(environment.serverIp + `v3/template?id=${id}`);
  }

  seeAllTemplates(id) {
    return this.http.get(
      environment.baseUrl + `admin/master/template/v2/?subIndustryId=${id}`,
    );
  }

  deleteTemplate(id) {
    return this.http.delete(
      environment.baseUrl + `admin/v3/template?templateId=${id}`,
    );
  }

  searchTemplate(searchText) {
    return this.http.get(
      environment.baseUrl + `admin/v3/template/?searchText=${searchText}`,
    );
  }

  updateTemplateComponentsData(data, tempId) {
    return this.http.put(
      environment.baseUrl + `admin/master/template/v2/${tempId}`,
      data,
    );
  }

  v3updateTemplateComponent(data) {
    return this.http.put(environment.serverIp + `v3/template`, data);
  }

  addMorePagesToExistingTemplate(data, templateId) {
    return this.http.put(
      environment.baseUrl + `admin/master/template/v2/${templateId}/page`,
      data,
    );
  }
  searchTemplateWithSubindustryandName(subIndustryId, searchText) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/template/v2/?subIndustryId=${subIndustryId}&text=${searchText}`,
    );
  }

  //get page details by page id
  getPageById(pageId) {
    return this.http.get(
      environment.baseUrl + `admin/master/template/v2/page/${pageId}`,
    );
  }

  //restyle template
  reStylePages(data) {
    return this.http.post(
      environment.baseUrl + `admin/master/template/v2/style`,
      data,
    );
  }

  regestirationTemplates(data: any) {
    return this.http.post(
      environment.baseUrl + `admin/master/template/v2/component`,
      data,
    );
  }

  getComponentsListByFilter(
    pageNo: number = 0,
    size: number = 1000,
    categoryId: string,
  ) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/template/v2/component?size=${size}&page=${pageNo}&categoryId=${categoryId}`,
    );
  }

  createContentFromSelections(sendingPayload: any) {
    return this.http.post(
      environment.baseUrl + `admin/master/template/v2/content`,
      sendingPayload,
    );
  }

  // Subindustry
  getSubIndustries(page: number, size: number) {
    return this.http.get(
      environment.baseUrl +
        `admin/master/business/industry/sub/count?pageNo=${page}&size=${size}`,
    );
  }

  // Unsplash
  searchPhotosInUnsplash(
    searchedText: string,
    page: number = 1,
    size: number = 10,
  ) {
    const header = new HttpHeaders({
      Authorization: `Client-ID ${environment.unsplash.UNSPLASH_API_TOKEN}`,
    });

    return this.http.get(
      `https://api.unsplash.com/search/photos?page=${page}&per_page=${size}&query=${searchedText}`,
      {
        headers: header,
      },
    );
  }

  // Shutterstock
  searchPhotosInShutterstock(
    searchedText: string,
    page: number = 1,
    size: number = 10,
  ) {
    const header = new HttpHeaders({
      Authorization: `Bearer ${environment.shutterstock.SHUTTERSTOCK_API_TOKEN}`,
    });

    return this.http.get(
      `https://api.shutterstock.com/v2/images/search?page=${page}&per_page=${size}&query=${searchedText}`,
      {
        headers: header,
      },
    );
  }

  // Media library
  saveImagesToBusinessLibrary(mediaRequest: { data: Media[] }) {
    return this.http.post(
      environment.baseUrl + `admin/library/image/library/save`,
      mediaRequest,
    );
  }

  getSavedImagesInLibrary(
    businessId: string,
    platform: MediaSource | string,
    pageNo: number,
    size: number,
  ) {
    return this.http.get(
      environment.baseUrl +
        `admin/library/image/library/list/paged?pageNo=${pageNo}&size=${size}&businessId=${businessId}&platform=${platform}`,
    );
  }

  // open ai API'S

  regenerateIndividual(data: any) {
    return this.http.post(
      environment.regenerateUrl + `content/suggest/website/individual`,
      data,
    );
  }

  regenerateContent(data: any) {
    return this.http.post(
      environment.regenerateUrl + `content/suggest/website`,
      data,
    );
  }

  // unsplash
  regenerateContentPhotos(query: string) {
    const headers = new HttpHeaders({
      Authorization: 'Client-ID ${this.accessKey}',
    });
    const url = `${this.apiUrl}/search/photos?query=${query}`;
    return this.http.get(url, { headers });
  }

  getComponentListV3() {
    return this.http.get(environment.baseUrl + `admin/v3/get/all/components`);
  }

  getSectionBySectionId(sectionId: any) {
    return this.http.get(
      environment.baseUrl + `admin/v3/component?id=${sectionId}`,
    );
  }

  getSectionForIndustry(sectionId: any, subIndustryId: any) {
    return this.http.get(
      environment.serverIp +
        `v3/add/section?subIndustryId=${subIndustryId}&componentId=${sectionId}`,
    );
  }

  getSectionForIndustry1(sectionId: any, subIndustryId: any, businessName: string, businessId: any) {
    return this.http.get(
      environment.serverIp + `v3/add/section?subIndustryId=${subIndustryId}&componentId=${sectionId}&name=${businessName}&businessId=${businessId}`
    )
  }

  // getSectionContent(sectionId:any , subIndustryId: any){
  //   return this.http.get(
  //     environment.baseUrl + `admin/v3/?subIndustryId=${subIndustryId}&categoryId=${sectionId}`
  //   )
  // }

  v3SaveContent(data: any) {
    return this.http.post(environment.baseUrl + `admin/v3/content`, data);
  }

  getContentById(contentId: any) {
    return this.http.get(
      environment.baseUrl + `admin/v3/content?id=${contentId}`,
    );
  }

  v3SavePage(data: any) {
    return this.http.post(environment.baseUrl + `admin/v3/page`, data);
  }

  v3GetListAllPages() {
    return this.http.get(environment.baseUrl + `admin/v3/page`);
  }

  v3GetListAllPagesWithSubIndustry(subId) {
    return this.http.get(environment.baseUrl + `admin/v3/page?subId=${subId}`);
  }

  v3CreateTemplate(data) {
    return this.http.post(environment.serverIp + `v3/template`, data);
  }
  v3ListTemplates() {
    return this.http.get(environment.baseUrl + `admin/v3/template`);
  }

  v3StudioIndustries() {
    return this.http.get(
      environment.baseUrl + `admin/v3/template/studio?allData=true`,
    );
  }

  v3StudioTemplesByIndustryId(id: any) {
    let staffType = localStorage.getItem('staffType') || 'ADMIN';
    let staffId = localStorage.getItem('staffId') || null;
    if (id === null) {
      return this.http.get(
        environment.baseUrl +
          `admin/v3/template/studio?allData=false&staffType=${staffType}&staffId=${staffId}`,
      );
    } else {
      return this.http.get(
        environment.baseUrl +
          `admin/v3/template/studio?subId=${id}&allData=false`,
      );
    }
  }
  v3seeAllTemplates(id) {
    return this.http.get(
      environment.baseUrl + `admin/v3/template/?subIndustryId=${id}`,
    );
  }
  v3getComponent(subId: any, componentId: any) {
    return this.http.get(
      environment.baseUrl +
        `admin/v3/component/content?subId=${subId}&componentId=${componentId}`,
    );
  }

  updateRegisteredComponent(data:any){
    return this.http.post(
      environment.baseUrl+`admin/v3/component`,data
    )
  }

  searchContent(subId: any, componentId: any, searchText: any) {
    return this.http.get(
      environment.baseUrl +
        `admin/v3/content/search?subId=${subId}&compId=${componentId}&searchText=${searchText}`,
    );
  }

  v3deleteContent(contentId: any) {
    return this.http.delete(
      environment.baseUrl + `admin/v3/content?contentId=${contentId}`,
    );
  }
  v3getAllTemplates(subId) {
    return this.http.get(
      environment.baseUrl + `admin/v3/template?subIndustryId=${subId}`,
    );
  }
  v3getSingleTemplateDetails(id) {
    return this.http.get(environment.baseUrl + `admin/v3/template?id=${id}`);
  }

  getComponentByContentId(contentId: string) {
    return this.http.get(
      environment.serverIp + `v3/content/id?contentId=${contentId}`,
    );
  }
  updateComponentContent(payload: any) {
    return this.http.get(environment.serverIp + `/v3/update/content`, payload);
  }
  getSectionContent(sectionId: any, subIndustryId: any) {
    return this.http.get(
      environment.serverIp +
        `v3/content/?subId=${subIndustryId}&componentId=${sectionId}`,
    );
  }

  getAllThemePallet() {
    return this.http.get(
      environment.serverIp + `master/template/v2/all-themes`,
    );
  }

  createTemplateV4(data: any) {
    return this.http.post(environment.serverIp + `v3/default/template`, data);
  }

  getTemplateById(id: any) {
    return this.http.get(environment.serverIp + `v3/template?id=${id}`);
  }

  getPageBySubIndustryId(subIndustryId: any, pageId: any) {
    return this.http.get(
      environment.serverIp +
        `v3/random/page?subId=${subIndustryId}&categoryId=${pageId}`,
    );
  }

  createImage(data: any) {
    return this.http.post(environment.serverIp + `v3/image`, data);
  }
  getAiImageData(size, page) {
    return this.http.get(
      environment.aiGeneratingBaseUrl +
        `api/images/all?limit=${size}&offset=${page}`,
    );
  }
  deleteAIImage(imageId: any) {
    return this.http.delete(
      environment.aiGeneratingBaseUrl + `api/images/${imageId}`,
    );
  }

  searchAiImageData(
    tags: string[],
    page: number,
    limit: number = 10,
    minScore: number = 0.7,
    logo: boolean = true,
  ) {
    let params = new HttpParams()
      .set('limit', limit.toString())
      .set('page', page.toString())
      .set('min_score', minScore.toString())
      .set('logo', logo.toString());

    tags.forEach((tag) => {
      params = params.append('tags', tag);
    });

    return this.http.get(
      `${environment.aiGeneratingBaseUrl}api/images/search`,
      { params },
    );
  }

  uploadImageForAiAgent(data) {
    return this.http.post(environment.aiGeneratingBaseUrl + `api/images`, data);
  }

  getImageData(data: any) {
    return this.http.put(environment.serverIp + `v3/image`, data);
  }

  deleteImage(imageId: any) {
    return this.http.delete(
      environment.serverIp + `v3/image?imageId=${imageId}`,
    );
  }

  getBlogsById(subIndustryId: any) {
    return this.http.get(
      environment.baseUrl + `admin/blog/getBlog/${subIndustryId}`,
    );
  }

  getBlogData(): Blog {
    const blogData: string | null = localStorage.getItem(
      Blog_Cachekeys.BLOG_SETTINGS,
    );

    return blogData ? new Blog(JSON.parse(blogData)) : new Blog();
  }

  setBlogData(blog: Blog) {
    localStorage.setItem(Blog_Cachekeys.BLOG_SETTINGS, JSON.stringify(blog));
  }

  filterDialog(
    componentName: any,
    panelClass: string,
    height: string,
    width: string,
    position: any,
    data: any,
    maxWidth: string = '95vw',
    maxHeight: string = '90vh',
  ) {
    return this.dialog.open(componentName, {
      panelClass: panelClass,
      width: width,
      height: height,
      position: position,
      data: data,
      disableClose: true,
      maxHeight: maxHeight,
      maxWidth: maxWidth,
    });
  }

  createBlog(data: Blog) {
    return this.http.post(environment.baseUrl + `admin/blog/create`, data);
  }

  openBottomSheet(componentName, panelClass, data: any) {
    return this.bottomSheet.open(componentName, {
      panelClass: panelClass,
      data: data,
    });
  }

  createBlogTags(blog: any) {
    return this.http.post(
      environment.baseUrl + `admin/blog/create/blogTag`,
      blog,
    );
  }

  createBlogAuthor(blog: any) {
    return this.http.post(
      environment.baseUrl + `admin/blog/create/blogAuthor`,
      blog,
    );
  }

  getAuthorsData() {
    return this.http.get(environment.baseUrl + `admin/blog/getAll/authors`);
  }

  updateAuthor(BlogTag: any) {
    return this.http.put(
      environment.baseUrl + `admin/blog/author/update`,
      BlogTag,
    );
  }

  deleteAuthor(authorId: any) {
    return this.http.delete(
      environment.baseUrl + `admin/blog/delete/author/${authorId}`,
    );
  }

  getTagsData() {
    return this.http.get(environment.baseUrl + `admin/blog/getAll/tags`);
  }

  updateBlogTag(BlogTag: any) {
    return this.http.put(
      environment.baseUrl + `admin/blog/tag/update`,
      BlogTag,
    );
  }

  deleteTags(tagId: any) {
    return this.http.delete(
      environment.baseUrl + `admin/blog/delete/tag/${tagId}`,
    );
  }

  updateBlog(data: Blog) {
    return this.http.put(
      environment.baseUrl + `admin/blog/master/update`,
      data,
    );
  }

  deleteBlog(blogId: any) {
    return this.http.delete(
      environment.baseUrl + `admin/blog/delete/${blogId}`,
    );
  }

  getAllComponent(websiteType?: 'STATIC' | 'E_COMMERCE') {
    if (websiteType) {
      return this.http.get(
        environment.serverIp + `v3/component/type?type=${websiteType}`,
      );
    } else {
      return this.http.get(environment.serverIp + `v3/component/type?type`);
    }
  }

  searchAllComponent(searchText: string) {
    return this.http.put(
      environment.serverIp + `v3/component/search?searchText=${searchText}`,
      '',
    );
  }

  getAllEcommerceIndustries() {
    return this.http.get(environment.serverIp + 'ecommerce/subIndustries');
  }

  getContentCount(subId: any) {
    return this.http.get(
      environment.serverIp + `v3/component/${subId}/content/count`,
    );
  }

  updateTemplateCategory(templateId: string, category: string) {
    return this.http.put(
      environment.serverIp +
        `v3/template/admin/${templateId}/update-category?category=${category}`,
      '',
    );
  }

  getAllComponents() {
    return this.http.get(environment.serverIp + `v3/get/all/components`);
  }
  getWebsiteTypes() {
    return this.http.get(environment.serverIp + `v3/get/websiteTypes`);
  }

  updateComponent(component: any) {
    return this.http.put(
      environment.serverIp + `v3/update/component`,
      component,
    );
  }
  changeTemplateStatus(
    templateId: any,
    templateStatus: any,
    rejectedReason: any,
  ) {
    return this.http.patch(
      environment.serverIp +
        `v3/template/update-status?templateId=${templateId}&status=${templateStatus}&rejectedReason=${rejectedReason}`,
      {},
    );
  }

  updateTemplate(data: any) {
    return this.http.patch(environment.serverIp + `v3/patch/template`, data);
  }
  getComponentApi(businessType?: 'STATIC' | 'E_COMMERCE') {
    return this.http.get(
      environment.baseUrl +
        `admin/master/template/category/all?type=${businessType ? businessType : ''}`,
    );
  }

  createPageV2(payload: any) {
    return this.http.post(environment.baseUrl + `admin/v3/admin/page`, payload);
  }
  pageNameCategory(subId: any) {
    return this.http.get(environment.baseUrl + `admin/v3/page?subId=${subId}`);
  }
  getPageBySubIndustryIdNew(pageId: any, subIndustryId: any) {
    return this.http.get(
      environment.baseUrl +
        `admin/v3/pagebyId?pageId=${pageId}&subId=${subIndustryId}`,
    );
  }

  generateTemplateByAI(data: any) {
    return this.http.post(
      environment.aiGeneratingBaseUrl + `api/template`,
      data,
    );
  }

  downloadExcelPrompts(
    templateId: string,
    templateName: string,
  ): Observable<Blob> {
    const url =
      environment.baseUrl +
      `admin/master/template/prompt/export?templateId=${templateId}&templateName=${templateName}`;
    return this.http.get(url, { responseType: 'blob' });
  }

  uploadExcelPrompts(templateId: string, file: File): Observable<any> {
    const url =
      environment.baseUrl +
      `admin/master/template/prompt/import?templateId=${templateId}`;
    const formData = new FormData();
    formData.append('file', file);
    return this.http.put(url, formData);
  }
  goBackPage = new EventEmitter<any>();

  getAllAIImages(status: any, size: any, page: any) {
    const statusQuery = status != null ? `status=${status}` : '';
    const endPoint = `api/images/search/new?${statusQuery}&size=${size}&page=${page}`;
    return this.http.get(environment.aiGeneratingBaseUrl + endPoint);
  }

  getAllPutAIImages(payload: any) {
    return this.http.put(
      environment.aiGeneratingBaseUrl + `api/images/search/new`,
      payload,
    );
  }

  requestChange(imageId, status) {
    return this.http.put(
      environment.aiGeneratingBaseUrl +
        `images/unsplash/status?image_id=${imageId}&image_status=${status}`,
      {},
    );
  }

  v3DuplicateTemplate(payload: any): Observable<any> {
    return this.http.post(
      environment.baseUrl + `admin/master/template/admin/v3/template/duplicate`,
      payload,
    );
  }
}
